import request from '@/utils/request'

export default {
	postLogin (account, password) {
		const params = {
			login_account: account,
			login_password: password
		}
		return request.post('/platformshop/passport/login', params)
	},
	getShopInfo (shopId) {
		return request.post('/platformshop/shops/getRow', { shop_id: shopId })
	},
    // 注册
    postSignup (params) {
        return request.post('/platformshop/passport/signup', params)
    },
    // 获取店铺列表列表
    getShopList () {
        return request.post('/platformshop/shops/getList')
    },
    // 注册协议
    getAgreement () {
        return request.post('/base/agreement/getShopAgreement')
    },
    // 图片滑动验证码
    get slideVerifyImage () {
        return `${window.apiBaseUrl}/../base/kit/captcha/slideimage?time=${+new Date()}`
    },
    // 发送验证码
    sendVerCode (params) {
        return request.post('/users/passport/sendVerCode', params)
    },
    // 忘记密码找回接口
    forget (params) {
        return request.post('/platformshop/passport/forget', params)
    }
}



// WEBPACK FOOTER //
// ./src/api/passport.js